import { useState } from "react";
import { api } from "../api";
import { navigate } from "../router";
import { haptic } from "../telegram";

export function HomePage() {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const create = async () => {
    setBusy(true);
    setError(null);
    try {
      const res = await api.createRoom();
      haptic("medium");
      navigate("lobby", { room: res.roomCode });
    } catch (e) {
      setError(e instanceof Error ? e.message : "خطا در ساخت اتاق");
    } finally {
      setBusy(false);
    }
  };

  const join = async () => {
    const c = code.trim().toUpperCase();
    if (c.length < 4) {
      setError("کد اتاق را کامل وارد کنید");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.joinRoom(c);
      haptic("medium");
      navigate("lobby", { room: c });
    } catch (e) {
      setError(e instanceof Error ? e.message : "پیوستن ناموفق بود");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="screen">
      <header className="header">
        <h1>🎲 منچ آنلاین</h1>
        <p className="muted">بازی ۲ تا ۴ نفره داخل تلگرام</p>
      </header>

      <div className="card">
        <button className="btn primary block" onClick={create} disabled={busy}>
          🎮 ساخت بازی جدید
        </button>
      </div>

      <div className="card">
        <label className="label">کد اتاق</label>
        <input
          className="input"
          placeholder="K7QX-2MPT"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          dir="ltr"
          maxLength={9}
        />
        <button className="btn block" onClick={join} disabled={busy}>
          👥 پیوستن به بازی
        </button>
      </div>

      {error && <div className="toast error">{error}</div>}

      <nav className="menu">
        <button onClick={() => navigate("profile")}>📊 پروفایل</button>
        <button onClick={() => navigate("leaderboard")}>🏆 جدول امتیازات</button>
        <button onClick={() => navigate("history")}>📜 تاریخچه</button>
      </nav>
    </div>
  );
}
